import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { OrderItem } from '@accounting/interfaces/order-item';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';

@Component({
  name: 'bpc-order-item-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-table-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
  },
})
export default class OrderItemTable extends mixins(AbstractTable) {
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: OrderItem = null;
  public entityName = 'order-item';
  public pluralEntityName = 'order-items';
  public permissionEntityNameToUse = 'orders';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  mounted() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].mounted(this);
    }
  }
  destroyed() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].destroy(this);
    }
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as OrderItem;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.order_id);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onNew() {
    this.entity = null;
    this.showForm = true;
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  onEdit(e, disabled = false) {
    this.entity = e.item;
    this.showForm = true;
    this.showDrawerSection = true;
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;

  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }

  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }

  // Here, put the same fields as you put in dataToShowForBulkTrashedEntity in your entity Service
  bulkMoveToTrashDataToShow = [['code'], ['article']];

  // Bulk restore modal (recover)

  showBulkRecoverModal = false;

  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }

  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }

  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  bulkRecoverDataToShow = [['code'], ['article']];
}
